// extracted by mini-css-extract-plugin
export default {"root":"AYjZDqgaU7oOZ4fbAK3i","loading":"f0d6RdFzlv8vooscQuZU","placeHolderShimmer":"bGQ4NGV3GBRpjv1sOgyk"};